import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Palette } from "lucide-react";
import BrandAssetsManager from "../../components/BrandAssets/BrandAssetsManager";

/**
 * Brand Assets Management Page
 * Standalone page for managing brand assets from the dashboard
 */
export default function BrandAssetsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F7F4' }}>
      {/* Header */}
      <div className="border-b sticky top-0 z-20" style={{ backgroundColor: '#F8F7F4', borderColor: '#D7B472' }}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate("/tailspin/dashboard")}
              className="p-2 rounded-lg transition-colors"
              style={{ color: '#0A0A10' }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(255, 107, 90, 0.1)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              <ArrowLeft className="w-5 h-5" style={{ color: '#0A0A10' }} />
            </button>
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg" style={{ backgroundColor: 'rgba(215, 180, 114, 0.15)' }}>
                <Palette className="w-6 h-6" style={{ color: '#D7B472' }} />
              </div>
              <div>
                <h1 className="text-2xl font-bold" style={{ color: '#0A0A10' }}>
                  Brand Assets
                </h1>
                <p className="text-sm" style={{ color: '#0A0A10', opacity: 0.7 }}>
                  Manage your brand identity and assets
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <BrandAssetsManager 
          showSaveButton={true}
          autoSave={false}
        />
      </div>
    </div>
  );
}

